import { fromJS } from 'immutable';

import { CREDIT_CARD_PAYMENT_TYPE, creditCardPaymentDataHandler } from '../creditcard/creditCardModule';

import { PAYPAL_PAYMENT_TYPE, paypalPaymentDataHandler } from '../paypal/paypalSerializers';
import { APPLE_PAY_PAYMENT_TYPE, applePayPaymentDataHandler } from '../applePay/applePaySerializers';
import { MASTERPASS_PAYMENT_TYPE, masterpassPaymentDataHandler } from '../masterpass/masterpassSerializers';


export const PAYMENT_STATUS = fromJS({
    INIT: 'init',
    ORDERING: 'ordering',
    FAILED: 'failed',
    SUCCESS: 'success'
});


export const initialState = fromJS({
    status: null,
    numAttempts: 0,
    response: null
});

export const PAYMENT_METHODS = {
    applePay: APPLE_PAY_PAYMENT_TYPE,
    paypal: PAYPAL_PAYMENT_TYPE,
    creditCard: CREDIT_CARD_PAYMENT_TYPE,
    masterpass: MASTERPASS_PAYMENT_TYPE
};


export const paymentMethodDataHandlers = fromJS({
    [APPLE_PAY_PAYMENT_TYPE]: applePayPaymentDataHandler,
    [CREDIT_CARD_PAYMENT_TYPE]: creditCardPaymentDataHandler,
    [PAYPAL_PAYMENT_TYPE]: paypalPaymentDataHandler,
    [MASTERPASS_PAYMENT_TYPE]: masterpassPaymentDataHandler
});


export const PROCESS_PAYMENT = '@@storefront/PROCESS_PAYMENT';
export const START_SEND_ORDER = '@@storefront/START_SEND_ORDER';
export const PAYMENT_COMPLETE = '@@storefront/PAYMENT_COMPLETE';
export const PAYMENT_SUCCESS = '@@storefront/PAYMENT_SUCCESS';
export const PAYMENT_FAILED = '@@storefront/PAYMENT_FAILED';
export const PAYMENT_RESET = '@@storefront/PAYMENT_RESET';


export default function reducer(state = initialState, action) {
    
    
    switch (action.type) {
        case PROCESS_PAYMENT:
            return state.merge({
                status: PAYMENT_STATUS.get('INIT'),
                numAttempts: state.get('numAttempts') + 1
            });
        case START_SEND_ORDER:
            return state.merge({ status: PAYMENT_STATUS.get('ORDERING') });
        case PAYMENT_SUCCESS:
            return state.merge({
                status: PAYMENT_STATUS.get('SUCCESS'),
                response: action.payload
            });
        case PAYMENT_FAILED:
            return state.merge({
                status: PAYMENT_STATUS.get('FAILED'),
                response: action.payload
            });
        case PAYMENT_COMPLETE:
            return initialState;
        case PAYMENT_RESET:
            return initialState;
        default:
    }
    return state;
}



export function processPayment(paymentMethod, paymentData) {
    return {
        type: PROCESS_PAYMENT,
        paymentMethod,
        paymentData
    };
}

export function startSendOrder() {
    return {
        type: START_SEND_ORDER
    };
}

export function paymentFailed(err) {
    return {
        type: PAYMENT_FAILED,
        payload: err
    };
}

export function paymentSuccess(resp) {
    return {
        type: PAYMENT_SUCCESS,
        payload: resp
    };
}

export function paymentComplete() {
    return {
        type: PAYMENT_COMPLETE
    };
}

export function paymentReset() {
    return {
        type: PAYMENT_RESET
    };
}
